/**
 * กระบี่ธารเยือกแข็ง (snow-sword): its lock routine (design docs/design/combat/2026-10-11-lock-moves-13.md §2.1, kit audit
 * docs/design/combat/2026-10-13-art-kit-audit.md piece 1). The lock move is ss-shift 彈 (a melee cut), not the old placeholder
 * ss-trace (a forward dash forced to lock by the rules sweep). Identity: crescent skates past the flank (not REED's circles),
 * weight piled on (snow on a bough, the foe sinks to a knee), then the spring: the bough snaps up and flings the foe. No warps:
 * those belong to its ท่าใหญ่ ss-hatred. Keys (ss* poses, frost/snow fx, ice/snow sfx) are the contract for the motion / FX /
 * sound lanes. Data only.
 */
import { registerLongMove } from './registry';

/** 彈 หิมะทับกิ่งสน — the flat of the blade binds, two skating crescents, three flicks of snow, the load, the bough snaps. */
export const SNOW_BOUGH = registerLongMove({
  skillId: 'ss-shift',
  kind: 'lock',
  name: 'หิมะทับกิ่งสน',
  opener: { type: 'contact', range: 0, tell: 0 },
  len: 5.2,
  catch: 0.45,
  power: 2.5,
  lunge: 1.0,
  beats: [
    { at: 0, pose: 'ssPress', hits: 0, share: 0, foe: 'hit', fx: 'frostBind', sfx: 'iceCreak', cam: 'hold' },
    { at: 0.45, pose: 'ssSkateL', hits: 1, share: 0.12, foe: 'hit', ai: 3, fx: 'frostArc', sfx: 'iceSkate', cam: 'orbit' },
    { at: 1.05, pose: 'ssSkateR', hits: 1, share: 0.12, foe: 'hit', ai: 3, fx: 'frostArc', sfx: 'iceSkate2', cam: 'orbit' },
    { at: 1.65, pose: 'ssShake', hits: 3, share: 0.24, foe: 'kneel', fx: 'flakeFall', sfx: 'snowSift3' },
    { at: 2.6, pose: 'ssLoad', hits: 0, share: 0, foe: 'kneel', fx: 'rimeCrust', sfx: 'boughCreak', cam: 'push' },
    {
      at: 3.3,
      pose: 'ssSnap',
      hits: 1,
      share: 0.52,
      foe: 'knock',
      dist: 1.8,
      ai: 2,
      stop: 0.08,
      fx: 'snowBurst',
      sfx: 'boughSnap',
      cam: 'shake',
    },
    { at: 3.9, pose: 'ssSettle', hits: 0, share: 0, foe: 'fall', fx: 'snowSettle', sfx: 'windHush' },
    { at: 4.6, pose: 'ssStance', hits: 0, share: 0, foe: 'recover' },
  ],
});
